import { __rest } from '../_virtual/_tslib.js';

const withCustomData = (tx, customData) => customData ? Object.assign(Object.assign({}, tx), {
  customData
}) : tx;
var writeTx = ((signer, populate) => _a => {
  var {
      customData
    } = _a,
    tx = __rest(_a, ["customData"]);
  return populate ? withCustomData(tx, customData) : signer.sendTransaction(tx).then(r => withCustomData(r, customData));
});

export { writeTx as default };
